import NewMemberCardContainer from './NewMemberCardContainer';

export default NewMemberCardContainer;
